import { valueType } from '@/utilities/constants';
export function useConditionValidator() {
    const test = {
        date: (str) => /\d{4}-\d{2}-\d{2}/.test(str),
        datetime: (str) => /\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}/.test(str),
        string: (str) => str.length > 0,
        number: (str) => str.length > 0 && !Number.isNaN(Number(str)),
        integer: (str) => test.number(str) && !str.includes('.'),
        decimal: (str) => test.number(str),
    };
    const field = (format, type, value) => {
        if (value === 0 || value) {
            const str = String(value);
            if (format === 'date_iso')
                return test.date(str);
            if (type === valueType.string)
                return test.string(str);
            if (type === valueType.integer)
                return test.integer(str);
            if (type === valueType.decimal)
                return test.decimal(str);
            return true;
        }
        return false;
    };
    const validateCondition = (condition, availableColumns) => {
        if (!condition.column)
            return false;
        const columnDetails = availableColumns.flatMap(group => group.columns).find(col => col.key === condition.column);
        if (!columnDetails)
            return false;
        const { type, format, options } = columnDetails;
        const isBetween = condition.operator === 'between';
        if (['isnull', 'notnull'].includes(condition.operator))
            return true;
        if (options) {
            const hasValue = Array.isArray(condition.value) ? condition.value.length > 0 : !!condition.value;
            return hasValue;
        }
        if (!field(format, type, condition.value?.[0]))
            return false;
        if (isBetween && !field(format, type, condition.value?.[1]))
            return false;
        return true;
    };
    return {
        validateCondition,
        field,
    };
}
